<template>
    <portal-section :title="section.name" :class="{'show-config-ui': showConfigUi}">
        <template #toolbar>
            <el-link v-if="showConfigUi" icon="el-icon-edit" @click="$emit('edit-section')" :underline="false"></el-link>
            <el-link v-if="showConfigUi" icon="el-icon-delete" @click="$emit('delete-section')" :underline="false"></el-link>
            <slot name="toolbar" :section="section"></slot>
        </template>
        <slot :section="section"></slot>
    </portal-section>
</template>

<script>
    import PortalSection from '../common/PortalSection'
    export default {
        name: "BaseSection",
        components: {PortalSection},
        props: {
            section: Object,
            showConfigUi: Boolean
        }
    }
</script>

<style scoped>

</style>
